import { cmsService } from '../../services'
import defaultErrors from '../../data/json/errors/errors'

const defaultState = {
  data: defaultErrors
}

const getters = {
  error: state => payload => {
    state.data = defaultErrors

    return cmsService.filterCMSContent(
      state.data.data,
      `${payload.errorKey}_${payload.route}`
    )
  }
}

const actions = {
  async loadErrors({ commit }) {
    commit('setErrors', { errors: defaultErrors })
  }
}

const mutations = {
  setErrors(state, { cmsErrors }) {
    state.data = cmsErrors
  }
}

export default {
  state: defaultState,
  getters,
  actions,
  mutations
}
